import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5e17acda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "serviceStatusSearch" }
const _hoisted_2 = ["id", "for"]
const _hoisted_3 = ["aria-label"]

import { ref, watch } from 'vue';
import { directive as vClickOutside } from 'click-outside-vue3';
import { Searchbox, Icon } from '../../Atoms';
import { RecentSearches } from '../../Molecules';
import { RecentOrSuggestedSearchEntry } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceStatusSearchbox',
  props: {
    placeholder: {},
    searchInputId: {},
    searchInputLabel: {},
    disabled: { type: Boolean },
    suggestions: {},
    suggestionsTitle: {},
    showSearches: { type: Boolean },
    showRouteMapButton: { type: Boolean },
    selectRouteMapCallback: { type: Function },
    hideSearchBtn: { type: Boolean }
  },
  emits: ['updateSearchValue', 'clearSearchValue', 'setShowSearches', 'getIsFocus', 'searchClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const searchValue = ref('');
const placeholder = ref(props.placeholder);

const hideSuggestions = () => {
  emit('setShowSearches', false);
};

const setSearchValue = (value) => {
  let inputText;
  value.ports.forEach((portname) => {
    inputText = inputText !== undefined ? `${inputText} - ${portname.name}` : portname.name;
  });

  searchValue.value = inputText;
  emit('updateSearchValue', inputText);
};

const searchClick = () => {
  if (searchValue.value.trim().length !== 0) {
    emit('searchClick');
  }
};

watch(() => props.placeholder, (newPlaceholder) => {
  placeholder.value = newPlaceholder;
});


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      id: _ctx.searchInputLabel ? _ctx.searchInputLabel : 'serviceStatusLabel',
      for: _ctx.searchInputId ? _ctx.searchInputId : 'serviceStatusInput'
    }, _toDisplayString(_ctx.$t('Search routes')), 9, _hoisted_2),
    _createVNode(_unref(Searchbox), {
      id: _ctx.searchInputId ? _ctx.searchInputId : 'serviceStatusInput',
      "aria-expanded": _ctx.showSearches,
      "aria-labelledby": _ctx.searchInputLabel ? _ctx.searchInputLabel : 'serviceStatusLabel',
      "aria-haspopup": "listbox",
      "aria-controls": "serviceStatusListbox",
      placeholder: placeholder.value,
      value: searchValue.value,
      disabled: _ctx.disabled ?? false,
      "hide-search-btn": _ctx.hideSearchBtn,
      error: false,
      onUpdate: _cache[1] || (_cache[1] = 
        (value) => {
          searchValue.value = value;
          _ctx.$emit('updateSearchValue', searchValue.value);
        }
      ),
      onSearchClick: searchClick,
      onSetIsFocus: _cache[2] || (_cache[2] = (isFocus) => _ctx.$emit('getIsFocus', isFocus))
    }, {
      default: _withCtx(() => [
        (searchValue.value.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["clearButton", { noSearchBtn: !_ctx.hideSearchBtn }]),
              "aria-label": _ctx.$t('Clear button aria label'),
              onClick: _cache[0] || (_cache[0] = 
          () => {
            searchValue.value = '';
            _ctx.$emit('clearSearchValue');
          }
        )
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('Clear')) + " ", 1),
              _createVNode(_unref(Icon), {
                "icon-name": "close",
                sm: ""
              })
            ], 10, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["id", "aria-expanded", "aria-labelledby", "placeholder", "value", "disabled", "hide-search-btn"]),
    _createVNode(_unref(RecentSearches), {
      title: _ctx.suggestionsTitle,
      "aria-labelledby": "serviceStatusLabel",
      "aria-id": "serviceStatusListbox",
      "show-searches": _ctx.showSearches,
      searches: _ctx.suggestions,
      "show-route-map-button": _ctx.showRouteMapButton,
      "select-route-map-callback": _ctx.selectRouteMapCallback,
      onSetSearchValue: _cache[3] || (_cache[3] = (value) => setSearchValue(value)),
      onSetShowSearches: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('setShowSearches'))),
      onSearchClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('searchClick')))
    }, null, 8, ["title", "show-searches", "searches", "show-route-map-button", "select-route-map-callback"]),
    _renderSlot(_ctx.$slots, "default")
  ])), [
    [_unref(vClickOutside), hideSuggestions]
  ])
}
}

})